import myKingLogo from "../assets/mykind_Logo.png";
import easytixLogo from "../assets/easytix_Logo.jpg";
import hormesisLogo from "../assets/hormesis_logo.png";
import radicalLogo from "../assets/radical-logo-2.svg";
import zoaLogo from "../assets/zoa_logo.jpeg";
import minkovskyLogo from "../assets/minkovsky.png";
import comedyClubLogo from "../assets/ccclogo.png";
import nimiLogo from "../assets/logo.png";
import accadiaLogo from "../assets/accadia_logo.png";
import tarbutaLogo from "../assets/tarbuta_logo.svg";
import adifplusLogo from "../assets/adifplus_logo.svg";
import globalMarketsLogo from "../assets/global_markets_logo.jpg";

import DefaultTermsOfService from '../assets/docs/nimi-terms-of-services.pdf'
import DefaultPrivacyPolicy from '../assets/docs/nimi-privacy-policy.pdf'

import { GenericLoader } from "../components/minimal/loading-screen/GenericLoader";
import { createMarketplaceLoader } from "../components/minimal/loading-screen/MarketplaceLoader";

const bootstrapData = {
    'mykind.cool': {
        name: 'MYKIND',
        favicons: {
            apple: "/favicon_my_kind/apple-touch-icon.png",
            large: "/favicon_my_kind/favicon-32x32.png",
            small: "/favicon_my_kind/favicon-16x16.png"
        },
        logo: {
            path: myKingLogo,
            width: "40px",
            height: "40px"
        },
        loader: {
            logo: myKingLogo,
            width: "40px",
            height: "40px"
        }
    },
    'easytix.co.il': {
        name: 'EASYTIX',
        favicons: {
            apple: "/favicon_easytix/apple-touch-icon.png",
            large: "/favicon_easytix/favicon-32x32.png",
            small: "/favicon_easytix/favicon-16x16.png"
        },
        logo: {
            path: easytixLogo,
            width: "auto",
            height: "80px"
        },
        loader: {
            logo: easytixLogo,
            width: "auto",
            height: "80px"
        }
    },
    'hormesis.club': {
        name: 'HORMESIS',
        favicons: {
            apple: "/favicon_hormesis/apple-touch-icon.png",
            large: "/favicon_hormesis/favicon-32x32.png",
            small: "/favicon_hormesis/favicon-16x16.png"
        },
        logo: {
            path: hormesisLogo,
            width: "100px",
            height: "25px"
        },
        loader: {
            logo: hormesisLogo,
            width: "100px",
            height: "25px"
        }
    },
    'radical.org.il': {
        name: 'RADICAL',
        favicons: {
            apple: "https://radical.org.il/wp-content/uploads/2021/06/fav.png",
            large: "https://radical.org.il/wp-content/uploads/2021/06/fav.png",
            small: "https://radical.org.il/wp-content/uploads/2021/06/fav.png"
        },
        logo: {
            path: radicalLogo,
            width: "auto",
            height: "25px"
        },
        loader: {
            logo: radicalLogo,
            width: "auto",
            height: "25px"
        }
    },
    'zoatlv.co.il': {
        name: 'ZOA',
        favicons: {
            apple: "/favicon_zoa/apple-touch-icon.png",
            large: "/favicon_zoa/favicon-32x32.png",
            small: "/favicon_zoa/favicon-16x16.png"
        },
        logo: {
            path: zoaLogo,
            width: "100px",
            height: "45px"
        },
        loader: {
            logo: zoaLogo,
            width: "100px",
            height: "45px"
        }
    },
    'minkovsky-records.com': {
        name: 'MINKOVSKY',
        favicons: {
            apple: "/favicon_minkovsky/apple-touch-icon.png",
            large: "/favicon_minkovsky/favicon-32x32.png",
            small: "/favicon_minkovsky/favicon-16x16.png"
        },
        logo: {
            path: minkovskyLogo,
            width: "100px",
            height: "45px"
        },
        loader: {
            logo: minkovskyLogo,
            width: "100px",
            height: "45px"
        }
    },
    'comedyclub.co.il': {
        name: 'COMEDYCLUB',
        favicons: {
            apple: "/favicon/ccc_favicon.png",
            large: "/favicon/ccc_favicon.png",
            small: "/favicon/ccc_favicon.png"
        },
        logo: {
            path: comedyClubLogo,
            width: "120px",
            height: "60px"
        },
        loader: {
            logo: comedyClubLogo,
            width: "120px",
            height: "60px"
        }
    },
    'villaaccadia.com': {
        defaultLang: 'en',
        name: 'ACCADIA',
        favicons: {
            apple: "/favicon_accadia/favicon.svg",
            large: "/favicon_accadia/favicon.svg",
            small: "/favicon_accadia/favicon.svg"
        },
        logo: {
            path: accadiaLogo,
            width: "80px",
            height: "80px"
        },
        loader: {
            logo: accadiaLogo,
            width: "80px",
            height: "80px"
        }
    },
    'tarbuta.com': {
        name: 'TARBUTA',
        favicons: {
            apple: "/favicon_tarbuta/favicon.svg",
            large: "/favicon_tarbuta/favicon.svg",
            small: "/favicon_tarbuta/favicon.svg"
        },
        logo: {
            path: tarbutaLogo,
            width: "auto",
            height: "100px"
        },
        loader: {
            logo: tarbutaLogo,
            width: "auto",
            height: "100px"
        }
    },
    'adifplus.co.il': {
        name: 'ADIFPLUS',
        favicons: {
            apple: "/favicon_adifplus/favicon.png",
            large: "/favicon_adifplus/favicon.png",
            small: "/favicon_adifplus/favicon.svg"
        },
        logo: {
            path: adifplusLogo,
            width: "auto",
            height: "80px"
        },
        loader: {
            logo: adifplusLogo,
            width: "auto",
            height: "80px"
        }
    },
    'global-markets.online': {
        defaultLang: 'en',
        name: 'global-markets',
        favicons: {
            apple: "/favicon_global_markets/favicon.jpeg",
            large: "/favicon_global_markets/favicon.jpeg",
            small: "/favicon_global_markets/favicon.jpeg"
        },
        logo: {
            path: globalMarketsLogo,
            width: "auto",
            height: "75px",
        },
        loader: {
            logo: globalMarketsLogo,
            width: "auto",
            height: "55px"
        }
    },
    'nimi.co.il': {
        name: 'NIMI',
        favicons: {
            apple: "/favicon/apple-touch-icon.png",
            large: "/favicon/favicon-32x32.png",
            small: "/favicon/favicon-16x16.png"
        },
        logo: {
            path: nimiLogo,
            width: "auto",
            height: "55px"
        },
        loader: {
            logo: nimiLogo,
            width: "auto",
            height: "55px"
        }
    },
}

export { easytixLogo, myKingLogo, hormesisLogo, radicalLogo, zoaLogo, minkovskyLogo, comedyClubLogo, globalMarketsLogo }

export const isEasyTix = () => {
    return window.location.host.includes('easytix') || window.location.search?.includes('easytix')
}
export const isHormesis = () => {
    return window.location.host.includes('hormesis') || window.location.search?.includes('hormesis')
}
export const isRadical = () => {
    return window.location.host.includes('radical') || window.location.search?.includes('radical')
}
export const isZoa = () => {
    return window.location.host.includes('zoa') || window.location.search?.includes('zoa')
}
export const isMinkovsky = () => {
    return window.location.host.includes('minkovsky') || window.location.search?.includes('minkovsky')
}
export const isComedyClub = () => {
    return window.location.host.includes('comedyclub') || window.location.search?.includes('comedyclub')
}
export const isNimi = () => {
    return window.location.host.includes('nimi') || window.location.search?.includes('nimi') || window.location.host.includes('localhost')
}
export const isAccadia = () => {
    return window.location.host.includes('villaaccadia') || window.location.search?.includes('villaaccadia')
}
export const isTarbuta = () => {
    return window.location.host.includes('tarbuta') || window.location.search?.includes('tarbuta');
}
export const isAdifPlus = () => {
    return window.location.host.includes('adifplus') || window.location.search?.includes('adifplus');
}
export const isProficientPath = () => {
    return window.location.host.includes('proficientpath') || window.location.search?.includes('proficientpath')
}


export const getMarketPlaceName = () => {
    return getBootstrapData().name;
}

export const getMarketPlaceEventPath = () => {
    return `${window.location.hostname}/event`
}


export const getMarketplaceLogo = () => {
    const { logo } = getBootstrapData();
    return logo || null;
}

export const getMarketplaceLoader = () => {
    const { loader } = getBootstrapData();
    return createMarketplaceLoader(loader);
}

export const getMarketPlaceTermsOfServiceAndPp = () => {
    return [DefaultTermsOfService, DefaultPrivacyPolicy]
}


export const getPageTitleByDomain = (title = "") => {
    if (title) {
        return `${title} | ${getMarketPlaceName()}`
    }
    return getMarketPlaceName()
}

export const getBootstrapData = () => {
    let { hostname } = window.location;
    if (hostname === 'localhost') {
        // extract the fake domain from the query params
        const urlParams = new URLSearchParams(window.location.search);
        const fakeDomain = urlParams.get('domain');
        if (fakeDomain) {
            hostname = fakeDomain;
        }
    }
    if (bootstrapData[hostname]) return bootstrapData[hostname]

    // we did not find the bootstrap data, so it might be a a subdomain
    for (const domain in bootstrapData) {
        if (hostname.endsWith(domain)) {
            return bootstrapData[domain]
        }
    }

    return bootstrapData['nimi.co.il'] // default to nimi
}